import { render, staticRenderFns } from "./RelRede.vue?vue&type=template&id=c686f65e"
import script from "./RelRede.vue?vue&type=script&lang=js"
export * from "./RelRede.vue?vue&type=script&lang=js"
import style0 from "./RelRede.vue?vue&type=style&index=0&id=c686f65e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports